import React from 'react'

const InputForm = (props) => {
    let { name = "", className = 'form', placeholder = '', defaultValue = '', onChange = () => { } } = props
    return (
        <input name={name} onChange={onChange} defaultValue={defaultValue} className={`input_${className}`} placeholder={placeholder} {...props} />
    )
}
export default InputForm